export default {
  state: {
    
    digitalLiteracy:{
        headers: [
            { text: 'Name', align: 'center', sortable: false, value: 'course_name' },
            // { text: 'Last Name', align: 'center', sortable: false, value: 'last_name' },
            // { text: 'Email', align: 'center', sortable: false, value: 'email' },
            { text: 'Actions', align: 'center', sortable: false, value: 'actions' }
        ],
        records: []
    },
      performance:{
          headers: [
              { text: 'Name', align: 'center', sortable: false, value: 'course_name' },
              { text: 'Actions', align: 'center', sortable: false, value: 'actions' }
          ],
          records: []
      },

  },
  getters: {
      getDLReports: (state) =>{
          var list = [];
          for (var i=0; i < state.digitalLiteracy.records.length; i++) {
              list.push(state.digitalLiteracy.records[i]);
          }
          // console.log("Make list", list);
          return list;
      },
  },
  mutations: {    
    setDLReports(state, data){
        console.log("Setting DL reports");
      state.digitalLiteracy.records = data
    },
    removeDLReports(state, data){
      state.digitalLiteracy.records = [];
    },
  },
  actions: {
    setDigitalLiteracyReports({commit}, data){
      commit('setDLReports', data);
    },
    removeDigitalLiteracyReports({commit}, data){
        commit('removeDLReports', data);
    },
  }
}